module.exports = __webpack_public_path__ + "img/traverse-logo.11207f61.svg";